import { css } from '@fable/theme'
import { RatingsGrid } from './chart'
import { useStatsBox } from '../../../lib/ctx/stats_box'
import { useRef } from 'react'
import { useGSAP } from '@gsap/react'
import { gsap } from 'gsap'

interface Props {
  skipAnim?: boolean
}

export const AvgRatingBarsContent = ({ skipAnim = false }: Props) => {
  const viewed = useStatsBox((s) => s.viewed)
  const scope = useRef<HTMLDivElement>(null)

  useGSAP(
    () => {
      const tl = gsap.timeline()

      const bars = gsap.utils.toArray('.anim__ratings-bar')

      if (skipAnim) {
        tl.set(bars, { height: '100%' })
        return
      }

      if (!viewed) return

      tl.to(bars, {
        height: '100%',
        duration: 1,
        stagger: 0.02,
        ease: 'power2.out',
      })
    },
    { scope, dependencies: [viewed] }
  )

  return (
    <div
      ref={scope}
      className={css`
        width: 100%;
        padding-bottom: 12px;
      `}
    >
      <RatingsGrid />
    </div>
  )
}
